<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITCheckbox, FITSelect, FITTextInput, FITInputTag, FITButton } from '@/components'
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'
export default {
  name: 'Shop',
  components: {
    FITCheckbox,
    FITSelect,
    FITTextInput,
    FITInputTag,
    FITButton,
    FITFormCard,
  },
  props: {},
  data() {
    return {

    }
  },
  // created() {
  //   document.title = this.$t('product.list.pageTitle.myShop');
  //   let token = Cookies.get('token');
  //   if (!token) {
  //     this.$store.dispatch('Auth/createTmpToken', { shopLink: this.currentRoute.query.link });
  //   }
  // },
  computed: {

  },
  created() {
    document.title = `${this.$t('kol.title')}`;
    this.$store.commit("hideFooter", false);


  },
  mounted() {

  },
  watch: {},

  methods: {
 
  },
}

</script>
<style type="text/css">
</style>



// WEBPACK FOOTER //
// src/Shop/containers/Shop.vue